export default __webpack_public_path__ + "static/media/visual-icon.af00ec31.svg";